/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { ARadioGroup, ARadio, AInput, ASelectCreate, ASelect } from 'components/Antd';
import ADatePicker from 'components/Antd/DatePicker';
import FormItem from 'views/DesktopReview/components/FormItem';
import classes from './AddDataModal.module.scss';

const TestField = ({
  form,
  countryListOptions,
  loadTestItems,
  handleCreateIssueParty,
  exportMarketId,
  onTestItemChanged,
  onCreateTestItemOption,
  issuePartyOptions,
  isRenew,
  disabled,
  options,
}) => {
  const [search, setSearch] = useState('');
  const lowerSearch = (search || '').toLowerCase();
  let isEmptyOptions = true;
  const relatedOptions = (options || []).filter((obj) => obj.sourceType === 'compliance');
  const customOptions = (options || []).filter((obj) => obj.sourceType !== 'compliance');
  const filteredOptions = [
    {
      label: 'Related',
      title: 'Related',
      value: 'Related',
      options: relatedOptions,
    },
    {
      label: 'Other',
      title: 'Other',
      value: 'Other',
      options: customOptions,
    },
  ].map((obj) => {
    const tObj = {
      ...obj,
      options: obj.options.filter((sObj) => {
        const sLabel = sObj.label || '';
        return !sLabel || sLabel.toLowerCase().includes(lowerSearch);
      }),
    };
    if (tObj.options.length > 0) {
      isEmptyOptions = false;
    }
    return tObj;
  });

  return (
    <>
      <FormItem
        label="Result"
        name="testResult"
        className={classes.testResultField}
        required={!disabled}
        rules={disabled ? undefined : [{ required: true, message: 'Please select result' }]}>
        <ARadioGroup disabled={disabled}>
          <ARadio value="pass" disabled={disabled}>
            Passed
          </ARadio>
          <ARadio value="fail" disabled={disabled}>
            Failed
          </ARadio>
          <ARadio value="reportAsIs" disabled={disabled}>
            Report As Is
          </ARadio>
        </ARadioGroup>
      </FormItem>
      <div className={classes.line13}>
        <FormItem
          required={!disabled}
          label="Export Market"
          name="exportMarket"
          rules={disabled ? undefined : [{ required: true, message: 'This field is required!' }]}>
          <ASelect
            allowClear
            showSearch
            placeholder="Select"
            options={countryListOptions}
            size="large"
            radius="md"
            virtual
            disabled={disabled || isRenew}
            onChange={(val) => {
              form.setFieldValue(`exportMarket`, val);
              form.setFieldValue(`testItem`, null);
              loadTestItems(val, '');
            }}
          />
        </FormItem>
        <FormItem
          required={!disabled}
          label="Test Item & Citation"
          name="testItem"
          rules={disabled ? undefined : [{ required: true, message: 'This field is required!' }]}>
          <ASelect
            allowClear
            showSearch
            placeholder="Fill or select"
            options={isEmptyOptions ? [] : filteredOptions}
            size="large"
            radius="md"
            virtual
            onChange={onTestItemChanged}
            disabled={disabled || !exportMarketId || isRenew}
            creatable
            isOriginalOptions
            onCreate={onCreateTestItemOption}
            onSearch={(val) => {
              setSearch(val);
            }}
          />
        </FormItem>
      </div>
      <div className={classes.line13}>
        <FormItem label="Report ID" name="reportId">
          <AInput
            size="large"
            name="reportId"
            placeholder="Fill here"
            minHeight
            radius="md"
            disabled={disabled}
          />
        </FormItem>
        <FormItem
          label="Issue Party"
          name="issueParty"
          rules={disabled ? undefined : [{ required: true, message: 'This field is required!' }]}
          required={!disabled}>
          <ASelectCreate
            placeholder="Fill or select"
            options={issuePartyOptions}
            showSearch
            size="large"
            radius="md"
            name="issueParty"
            allowClear
            disabled={disabled}
            onCreate={handleCreateIssueParty}
            filterOption={(inputValue, option) => {
              return option.label.toLowerCase().includes(inputValue.toLowerCase());
            }}
          />
        </FormItem>
      </div>
      <div className={classes.line12}>
        <FormItem label="Expiry Date" name="expiryDate">
          <ADatePicker
            name="expiryDate"
            size="large"
            radius="md"
            placeholder="Select date"
            disabled={disabled}
          />
        </FormItem>
        <FormItem style={{ width: '100%' }} label="Test Date / Report Date" name="testDate">
          <ADatePicker
            name="testDate"
            size="large"
            radius="md"
            placeholder="Select date"
            disabled={disabled}
          />
        </FormItem>
      </div>
    </>
  );
};

export default TestField;
